import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["badge", "count"]
  static values = {
    resourceName: String,
    scopeId: Number,
    ownerType: String
  }

  connect() {
    this.updateBadge()
    setTimeout(() => this.updateBadge(), 100)

    document.addEventListener('selection:changed', this.handleSelectionChange.bind(this))
    document.addEventListener('selection:cleared', this.handleSelectionCleared.bind(this))
  }

  disconnect() {
    document.removeEventListener('selection:changed', this.handleSelectionChange.bind(this))
    document.removeEventListener('selection:cleared', this.handleSelectionCleared.bind(this))
  }

  handleSelectionChange(event) {
    if (event.detail.resourceName === this.resourceNameValue) {
      this.updateBadge()
    }
  }

  handleSelectionCleared(event) {
    if (event.detail.resourceName === this.resourceNameValue) {
      this.updateBadge()
    }
  }

  updateBadge() {
    let count = 0

    const selectionController = this.getSelectionController()
    if (selectionController) {
      count = selectionController.getCount()
    } else {
      const scopeId = this.hasScopeIdValue ? this.scopeIdValue : ''
      const ownerType = this.hasOwnerTypeValue ? this.ownerTypeValue : 'org'
      const prefix = scopeId ? `${ownerType}_${scopeId}_` : ''
      const storageKey = `table_selection_${prefix}${this.resourceNameValue}_ids`
      const storedIds = sessionStorage.getItem(storageKey)
      if (storedIds) {
        try {
          const ids = JSON.parse(storedIds)
          count = Array.isArray(ids) ? ids.length : 0
        } catch (e) {
          count = 0
        }
      }
    }

    if (this.hasBadgeTarget && this.hasCountTarget) {
      if (count > 0) {
        this.badgeTarget.style.display = 'inline-block'
        this.countTarget.textContent = count
      } else {
        this.badgeTarget.style.display = 'none'
      }
    }
  }

  getSelectionController() {
    const forms = document.querySelectorAll('[data-controller*="table-selection"]')
    let targetForm = null

    for (const form of forms) {
      if (form.offsetParent !== null) {
        targetForm = form
        break
      }
    }

    if (!targetForm && forms.length > 0) {
      targetForm = forms[0]
    }

    if (!targetForm) return null
    return this.application.getControllerForElementAndIdentifier(targetForm, 'table-selection')
  }
}
